const AdminRoles = {
	Executive: "Executive",
	DirectorCustomerService: "Director Customer Service",
	DirectorTechSupport: "Director Tech Support",
	DirectorBoarding: "Director Boarding",
	DirectorAgentRelations: "Director Agent Relations",
	DirectorRiskCredit: "Director Risk/Credit",
	RiskAnalystUnderwriter: "Risk Analyst/Underwriter",
	CustomerService: "Customer Service",
	TechSupport: "Tech Support",
	Boarding: "Boarding",
	AgentRelations: "Agent Relations",
	InsideSalesManagerBusinessDevelopment:
		"Inside Sales Manager/Business Development",
	InsideSales: "Inside Sales",
	Finance: "Finance",
	DirectorFinance: "Director Finance",
};

export { AdminRoles };
